import { util } from './util.js';
import { color } from './color.js';

export async function extractVgData($state, $spec, $vl_spec, $context, $org_data, $size, chart_size, fronto_spec, $compiledFronto, internal_texts) {
  let original_state = $state;
  let original_spec = $spec;
  let vl_spec = $vl_spec;
  let context = $context;
  let original_data = ($org_data ? $org_data : $state);
  let aggregate_set, aggregate_transforms;
  let n_layers = 0, raw_set = [], field_set = [];
  let encoding_set = {}, scales_set = {};
  let original_dataset = original_data.values.input.value;

  // not important at the momment
  if (original_spec.data[0].transform !== undefined && original_spec.data[0].transform.length > 0) {
    aggregate_transforms = original_spec.data[0].transform.filter(function (e) { return e.type === "aggregate" });
  }

  if (aggregate_transforms !== undefined) {
    let agg_set_flag = true, agg_set_cnt_flag = 0;
    let agg_set_source = original_data.values.output.source;

    while (agg_set_flag && agg_set_cnt_flag < 10) {
      if (agg_set_source === undefined) {
        agg_set_flag = false;
      } else if (agg_set_source.constructor.name === "Aggregate") {
        agg_set_flag = false;
        aggregate_set = agg_set_source.value;
      } else {
        agg_set_source = agg_set_source.source;
        agg_set_cnt_flag++;
      }
    }
  }

  // tested: non-aggreated bar, line, point;
  // tested: simple bar; line; point; histogram; bar + nominal color (stack); line + nominal color; point + nominal color; histogram + nominal color (stack)


  async function processRawFacets() {
    /*
      extracts "raw" encoding info for "facets"
      returns itself (object instance) for chaining
    */
    let state = original_state,
      $n_layers = 0;
    for (let i = 0; i < state.length; i++) { // for each facet in the subcontext
      let mark_list_keys = Object.keys(state[i].data).filter(function (el) {
        return util.isMarkLayer(el) || util.isPathGroupLayer(el)
      });
      // filter arrays for "mark" items
      for (let j = 0; j < mark_list_keys.length; j++) { // for each mark item list
        let lkey = mark_list_keys[j];
        if (util.isPathGroupLayer(lkey)) {
          let item_list = state[i].data[lkey];
          let mark_type = item_list.values.value[0].items[0].marktype;
          raw_set.push({
            name: lkey,
            items: item_list,
            type: mark_type
          });
          field_set.push(...Object.keys(item_list.input.value[0].datum));
        } else if (util.isMarkLayer(lkey)) {
          let item_list = state[i].data[lkey];
          let mark_type = item_list.values.value[0].mark.marktype;
          raw_set.push({
            name: lkey,
            items: item_list,
            type: mark_type
          });
          field_set.push(...Object.keys(item_list.input.value[0].datum));
        }
        $n_layers++; //count for # of facets
      }
    }
    field_set = Array.from(new Set(field_set));
    n_layers = $n_layers;
  }

  async function processRawLayers() {
    /*
      extracts "raw" encoding info for "layers"
      returns itself (object instance) for chaining
    */
    let state = original_state;
    let $n_layers = 0,
      data_keys = Object.keys(state);
    if (data_keys.indexOf("marks") > -1 && data_keys.length == 1) { // when there is only 1 layer
      $n_layers = 1;
      let mark_type = state.marks.values.value[0]._svg.ariaRoleDescription;
      raw_set.push({
        name: "marks",
        items: state.marks,
        type: mark_type
      });
      field_set = Object.keys(state.values.input.value[0]);
    } else if (data_keys.indexOf("pathgroup") > -1 && data_keys.length == 1) { // when there is only 1 layer, pathgroup
      $n_layers = 1;
      let mark_type = state.marks.values.value[0].ariaRoleDescription;
      let lkey = data_keys.indexOf("pathgroup")
      raw_set.push({
        name: data_keys[lkey],
        items: state.marks,
        type: mark_type
      });
      field_set = Object.keys(state.values.input.value[0]);
    } else { // when there are 2 or more layers // not stable!!!!!!
      let mark_layers = Object.keys(state).filter(function (el) {
        return util.isMarkLayer(el) || util.isPathGroupLayer(el);
      }); // filter arrays that have mark info for each layer
      for (const lkey of mark_layers) { // for each layer
        let isPathGroup = util.isPathGroupLayer(lkey);
        let layer_set = state[lkey];
        let mark_type = isPathGroup ? layer_set.values.value?.[0]?.items?.[0]?.marktype : layer_set.values.value?.[0]?.ariaRoleDescription;
        raw_set.push({
          name: lkey,
          items: layer_set,
          type: mark_type
        });
        $n_layers++; //count for # of layers
      }
      field_set = Object.keys(state.values.input.value[0]);
    }
    n_layers = $n_layers;
  }

  async function processScale() {
    /*
      refine scales info to be associated with fields
      returns itself for chaining
    */
    let spec = original_spec;
    let scales = spec.scales,
      data = spec.data.values;
    let save_scale = [];
    for (const scale of (scales || [])) { // for each scale
      let temp_scale_item = { // temp save
        name: scale.name,
        type: scale.type,
        zero: scale.zero
      };
      // dealing with domain

      if (scale.domain != undefined && scale.domain.hasOwnProperty("field")) { // case 1: having a specified field
        let org_field_name = scale.domain.field;
        temp_scale_item.domain = {
          field: [org_field_name],
          source: scale.domain.data,
          transform: (scale.domain.field == "__count" ? "aggregate" : null)
        }
        if (scale.domain.sort) { // if sorted
          temp_scale_item.domain.sort = scale.domain.sort;
        } else { // if not sorted
          temp_scale_item.domain.sort = null;
        }
      } else if (scale.domain != undefined && scale.domain.hasOwnProperty("fields")) { // case 2: having a specified, transformed field
        if (scale.domain.fields.length > 1 &&
          scale.domain.fields[0].field &&
          scale.domain.fields[0].field.startsWith("bin_") &&
          scale.domain.fields[0].field + "_end" === scale.domain.fields[1].field) { // case 2-1: having binned fields
          temp_scale_item.domain = {
            field: [scale.domain.fields[0].field.replace("bin_", "")],
            source: scale.domain.fields[0].data,
            transform: "bin"
          }
        } else if (scale.domain.fields.length > 1 &&
          scale.domain.fields[0].field &&
          scale.domain.fields[0].field.startsWith("__calc_") &&
          scale.domain.fields[0].field + "_end" === scale.domain.fields[1].field) { // case 2-2: handling example cases (needs further extension)
          temp_scale_item.domain = {
            field: [scale.domain.fields[0].field.replace("__calc_", "")],
            source: scale.domain.fields[0].data,
            transform: "calculation"
          }
        } else { // case 2-3: count field
          temp_scale_item.domain = {
            field: [scale.domain.fields[0].field],
            source: scale.domain.fields[0].data,
            transform: (scale.domain.field === "__count" ? "aggregate" : null)
          }
        }
        if (scale.domain.fields[0].sort) { // if sorted
          temp_scale_item.domain.sort = scale.domain.fields[0].sort;
        } else { // if not sorted
          temp_scale_item.domain.sort = null;
        }
      } else if (scale.domain != undefined && scale.domain.constructor === Array) { // case 3: having a manually defined domain (no sorting info)
        temp_scale_item.domain = {
          field: [],
          manual: scale.domain,
          sort: null
        }
      } else { // case 4: transformed scale
        if (scale.hasOwnProperty("bins")) { // having transformed bins
          let signal = scale.bins.signal;
          for (const datum of data) {
            let used_transform = datum.transform.filter(function (et) {
              return et.signal === signal
            });
            if (used_transform.length > 0) {
              temp_scale_item.domain = {
                field: [used_transform[0].field],
                transform: used_transform[0].type,
                maxbins: used_transform[0].maxbins,
                source: datum.name,
                sort: true
              };
            }
          }
        }
      } // done domain

      // dealing with range
      if (scale.range.constructor === Array) { // case 1: array range
        temp_scale_item.range = {
          type: "array",
          range: []
        }
        for (const r of scale.range) {
          if (r?.hasOwnProperty("signal")) { // case 1-1: signalled range value
            if (r.signal == "width" || r.signal == "height") {
              temp_scale_item.range.range.push(spec[r.signal]);
            } else {
              temp_scale_item.range.range.push(
                spec.signals.filter(function (s) {
                  return s.name == r.signal
                })[0].value
              );
            }
          } else {
            temp_scale_item.range.range.push(r);
          }
        }
      } else if (scale.range.constructor == String) { // case 2: string range (categorical)
        temp_scale_item.range = {
          type: "auto",
          range: scale.range
        };
      } else if (scale.range.hasOwnProperty("scheme")) { // case 3: having a predefined scheme
        temp_scale_item.range = {
          type: "scheme",
          range: scale.range
        }
      } // done range

      save_scale.push(temp_scale_item); // done for a scale
    }
    //saving
    scales_set = save_scale;
  }

  async function getFieldType(field_name, channel) {
    // use after getEncodingFields
    let scales = scales_set;
    let filtered = scales.filter(function (e) { return e.domain.field.includes(field_name) && e.name.endsWith(channel) })[0]
    if (filtered !== undefined) return filtered.type;
    else if (field_name === "$highlight") return "nominal";
    else return undefined;
  }

  async function getEncodingFields(layer_name, mSpec, data_name) {
    /*
      @layer_name: the name of the current layer/facet
      @mSpec: layer information in the vega spec
      returns encoding-data_field mapping
    */
    let fields = {};
    let scales = scales_set;
    let ecs = mSpec.encode.update;
    for (const fkey of util.vgFields) { // for each encoding (detailed)
      if (ecs[fkey]) { // when layer's encoding space has the encoding channel
        if (ecs[fkey].scale && ecs[fkey].field || ecs[fkey].constructor === Array) { // when there's a defined scale and properly associated data field
          let scale_elem;
          if (ecs[fkey].constructor === Array) {
            scale_elem = ecs[fkey].filter(function (e) { // get the element that has scale info
              return e.hasOwnProperty('scale');
            })[0];
            if (!scale_elem) {
              let temp_elem = ecs[fkey].filter(function (e) { // get the element that has scale info
                return e.hasOwnProperty('signal');
              })[0];
              if (temp_elem) {
                scale_elem = { scale: fkey, field: util.searchBestFitField(temp_elem.signal, scales) };
              }
              else {
                let temp_elem2 = ecs[fkey].filter(function (e) { // get the element that has scale info
                  return e.hasOwnProperty('text');
                })[0];
                if (temp_elem2) {
                  fields[fkey] = "$highlight";
                }
              }
            }
          } else if (ecs[fkey].scale && ecs[fkey].field) {
            scale_elem = ecs[fkey];
          }
          if (scale_elem) { // if there is a scale info
            let enc = (scale_elem.scale ? scale_elem.scale : fkey);
            let scale = scales.filter(function (s) {
              return s.name == enc;
            })[0];
            let scale_field = scale.domain; // get scale's field name (which is more likely to be proper)
            if (scale_field.field.length == 0) { // if the scale has no associated field
              fields[fkey] = scale_elem.field;
              scale_field.field.push(scale_elem.field);
            } else if (!(scale_field.hasOwnProperty("transform") && scale_field.transform === "bin")) { // if the scale has a proper field name but not bin
              if (scale_field.field.includes(scale_elem.field)) fields[fkey] = scale_elem.field;
              else {
                fields[fkey] = scale_elem.field;
                scale_field.field.push(scale_elem.field);
              }
            } else if (scale_field.hasOwnProperty("transform") && scale_field.transform === "bin") {
              fields[fkey] = scale_field.field[0];
            } else {
              fields[fkey] = undefined;
            }
          } else {
            fields[fkey] = undefined;
          }
        } else if (ecs[fkey].scale && ecs[fkey].value === 0) { // when there's a defined scale but with a constant value
          if (util.vgEncConversion[fkey] === "x") {
            if (fkey === "x2") fields[fkey] = ecs["x"].field; // x2-x handling
            else if (fkey === "x") fields[fkey] = ecs["x2"].field; // x-x2 handling
          } else if (util.vgEncConversion[fkey] === "y") {
            if (fkey === "y2") fields[fkey] = ecs["y"].field; // y2-y handling
            else if (fkey === "y") fields[fkey] = ecs["y2"].field; // y-y2 handling
          } else fields[fkey] = undefined; // not usable
        } else if (!ecs[fkey].scale && ecs[fkey].signal && ecs[fkey].signal.constructor === String) {
          // when the encoding channel has only "signal" (string-valued) info without scale info
          fields[fkey] = undefined;
          let first = ecs[fkey].signal.indexOf("datum[\"") + "datum[\"".length,
            second = ecs[fkey].signal.indexOf("\"]");
          if (first >= 0 && second > first) {
            let as = ecs[fkey].signal.substring(first, second);
            if (as) { // when there's "as" value
              let datasource = original_spec.data.filter(function (d) {
                return d.name === data_name
              })[0]; // get the data source
              if (datasource && datasource.transform) { // get the associated transform
                let trfm = datasource.transform.filter(function (t) {
                  return t.as === as || (t.as && t.as.constructor === Array && t.as.includes(as));
                })[0];
                if (trfm && trfm.expr) { // when it has calculation expression
                  let fieldname = util.searchBestFitField(trfm.expr, scales); // expression has the field
                  if (fieldname) {
                    fields[fkey] = fieldname;
                    scales.push({
                      name: fkey,
                      type: "calculate",
                      zero: null,
                      domain: {
                        field: [fieldname]
                      },
                      range: {
                        type: "auto",
                        range: trfm.expr
                      }
                    });
                  }
                } else if (trfm && trfm.field) {
                  fields[fkey] = trfm.field;
                }
              }
            }
          }
        } else if (ecs[fkey].field && ecs[fkey].field.endsWith("_" + fkey)) { // else
          fields[fkey] = ecs[fkey].field;
        } else { // else
          fields[fkey] = undefined;
        }
      }
    }
    return fields;
  }

  function locateAggregateSet(sudo_key) {
    /*
      @sudo_key: an object that can filter aggregate_set
      it first generates key using grammar, and then search
    */
    function makeKey(ksb, sk) {
      let result = [];
      for (let k of ksb) {
        result.push(sk[k]);
      }
      return result.join("|");
    }
    if (aggregate_transforms.length == 1) {
      let key_sort_by = aggregate_transforms[0].groupby;
      let search_key = makeKey(key_sort_by, sudo_key)
      return aggregate_set[search_key];
    } else {
      for (let trfm of aggregate_transforms) {
        let key_sort_by = trfm.groupby;
        let search_key = makeKey(key_sort_by, sudo_key)
        if (aggregate_set[search_key] !== undefined) {
          return aggregate_set[search_key];
        }
      }
    }

  }

  async function processEncoding() {
    let spec = original_spec; // VEGA specificationd
    for (let i = 0; i < n_layers; i++) { // for each layer
      let lm = raw_set[i]; // current facet or layer
      let group_name = lm.name; // layer's name
      if (group_name.includes("__endMark")) continue;
      let layer_info_vega; // to save layer/facet info from VEGA Spec
      // part A: get layer name;
      if (context === "layers") { // for layer
        layer_info_vega = spec.marks.filter(function (el) {
          return el.name == group_name;
        })[0];
        if (util.isPathGroupLayer(group_name)) { // for line marks
          let dt = layer_info_vega.from.facet.data;
          layer_info_vega = layer_info_vega.marks[0];
          layer_info_vega.from.data = dt;
        }
      } else if (context === "facets") { // for facet
        let group_name_spec_vars = [
          group_name.replace("_marks", "_group"), // for encoding level facets
          group_name.replace("_child_marks", "_cell"), // for repeated layouts
          group_name.replace(/\_child\_layer\_[0-9]\_marks$/, "_cell"),
          group_name.replace(/\_child\_layer\_[0-9]\_pathgroup$/, "_cell"),
          "pathgroup", // for repeated paths
          "cell", // for layout level facets
        ];
        let group_spec = spec.marks.filter(function (el) {
          return el.type === "group" && (group_name_spec_vars.includes(el.name));
        })[0];
        layer_info_vega = group_spec.marks.filter(function (el) {
          return el.name === group_name || el.name === "marks";
        })[0];
        if (util.isPathGroupLayer(group_name)) { // for line marks
          let dt = layer_info_vega.from.facet.data;
          layer_info_vega = layer_info_vega.marks[0];
          layer_info_vega.from.data = dt;
        }
        if (group_spec.from?.facet && group_spec.from?.facet?.name && group_spec.from?.facet?.data) {
          layer_info_vega.from.facet_name = group_spec.from.facet.name;
          layer_info_vega.from.data = group_spec.from.facet.data;
          layer_info_vega.from.field = group_spec.from.facet.groupby[0];
        }
      }

      // part B: getting data fields
      let transform = null;
      let data_name = layer_info_vega.from.data,
        data_def_vega = spec.data.filter(function (e) {
          return e.name == data_name
        })[0];
      // case where its transformed data
      if (data_def_vega && data_def_vega.transform) {
        let loes_reg = data_def_vega.transform.filter(function (e) {
          return e.type == "loess" || e.type == "regression"
        });
        if (loes_reg.length > 0) transform = loes_reg[0].type;
      }

      // part C: getting data fields associated with each encodings
      let fields = await getEncodingFields(group_name, layer_info_vega, data_def_vega.name);
      let mark_items = [];
      let layer_lm_items;

      if (util.isPathGroupLayer(group_name)) {
        layer_lm_items = [];
        let lmItems = lm.items.values.value;
        for (let i = 0; i < lmItems?.length; i++) {
          let item = lmItems[i];
          let mark_points = item.items[0].items.map(function (e) {
            e.subgroup = group_name + "_" + i;
            return e;
          });
          layer_lm_items.push(...mark_points);
        }
      } else {
        layer_lm_items = lm.items.values.value;
      }
      if (layer_lm_items && !layer_lm_items?.every(lmitem => lmitem.description == undefined || lmitem.description == null)) {
        // part D: extracting each mark data
        for (let lmitem of layer_lm_items) { // for each mark in the layer/facet
          // section D1: transformation check, cleaning
          let _d = lmitem.datum; // data value
          if (transform != null) {
            let datakeys = Object.keys(_d).filter(function (e) {
              return e != "Symbol(vega_id)"
            });
            for (const datakey of datakeys) {
              delete Object.assign(_d, {
                [datakey + "_" + transform]: _d[datakey]
              })[datakey];
            }
          }
          // Treating Bin Pairs
          let datakeys = Object.keys(_d).filter(function (e) {
            return e != "Symbol(vega_id)"
          });
          for (let dfld of datakeys) {
            let seps = dfld.split("_")
            if (seps[0] === "bin" && _d[dfld] !== undefined && _d[dfld + "_end"] !== undefined) {
              _d[remove_bin_aux(dfld)] = _d[dfld]
            }
          }
          // section D2: get agg;
          if (aggregate_set !== undefined) {
            loc_agg = locateAggregateSet(_d);
            _d.n_points = (loc_agg !== undefined ? loc_agg.num : 1)
          } else {
            _d.n_points = 1;
          }
          // section D3: getting encoded values
          let m = {};
          for (const eca of util.vgFields) { // for each encoding
            let ec = (eca === "detail" ? "subgroup" : eca);
            if (lmitem[ec] !== undefined) {
              let _f = (fields[ec] == "" ? null : fields[ec])
              if (_f === undefined) {
                if (ec === 'x2' && fields['x'] !== undefined) _f = fields['x'];
                if (ec === 'y2' && fields['y'] !== undefined) _f = fields['y'];
              }
              m[ec] = { // v: value for the encoding, f: associated field
                "value": lmitem[ec],
                "field": _f
              };
              let ft = await getFieldType(m[ec].field, ec);
              if (ft === undefined) {
                ft = await getFieldType(m[ec].field, util.vgEncConversion[ec]);
              }
              let ft_is_non_quant = util.vgScaleTypesByOrient.non_quantitative.includes(ft);
              m[ec]["datatype"] = (ft !== undefined ? ft : 'unknown');
              m[ec]["datatype_class"] = (ft_is_non_quant ? 'nominal' : 'quantitative');
            }
          }
          // area bbox: supported mark types: 
          // bar, rect, tick **
          // circle, point, square **
          // area **
          // line **
          // rule **
          // text **
          let parent = {
            width: lmitem.mark.group.width,
            height: lmitem.mark.group.height,
            x: lmitem.mark.group.x || lmitem.mark.group.mark.group?.x,
            y: lmitem.mark.group.y || lmitem.mark.group.mark.group?.y
          };
          let _bbox = {};
          let xbound = (parent.x !== undefined ? parent.x : lmitem.mark.group.bounds.x1);
          let ybound = (parent.y !== undefined ? parent.y : lmitem.mark.group.bounds.y1);
          //get either x or y are quantitative
          if (["bar", "rect", "tick"].includes(lmitem.ariaRoleDescription) || ["rect"].includes(lmitem.mark.marktype)) {
            _bbox.svg = null;
            _bbox.width = lmitem.width;
            _bbox.height = lmitem.height;
            _bbox.area = _bbox.width * _bbox.height;
            _bbox.detail = lmitem.bounds;
            _bbox.color = lmitem.fill;
            _bbox.origin_box = { x: xbound, y: ybound, width: parent.width, height: parent.height };
            _bbox.absBox = {
              x1: xbound + lmitem.x,
              x2: xbound + lmitem.x + _bbox.width,
              y1: ybound + lmitem.y,
              y2: ybound + lmitem.y + _bbox.height
            };
            _bbox.absBox.xc = (_bbox.absBox.x1 + _bbox.absBox.x2) / 2;
            _bbox.absBox.yc = (_bbox.absBox.y1 + _bbox.absBox.y2) / 2;
            _bbox.individual = true;
            _bbox.markType = (lmitem.ariaRoleDescription !== undefined ? lmitem.ariaRoleDescription : lmitem.mark.marktype);
            _bbox.markShape = "rect";
            if (_bbox.markType === "bar") {
              let scaleX = spec.scales.filter(function (e) { return e.name === "x" })[0];
              let scaleY = spec.scales.filter(function (e) { return e.name === "y" })[0];
              if (scaleX?.hasOwnProperty('bins')) _bbox.orient = util.cOrient.vertical;
              else if (scaleY?.hasOwnProperty('bins')) _bbox.orient = util.cOrient.horizontal;
              else if (util.vgScaleTypesByOrient.non_quantitative.includes(scaleX?.type)) _bbox.orient = util.cOrient.vertical;
              else if (util.vgScaleTypesByOrient.non_quantitative.includes(scaleY?.type)) _bbox.orient = util.cOrient.horizontal;
            }
          } else if (["circle", "point", "square"].includes(lmitem.ariaRoleDescription)) {
            // let svgbbox = lmitem._svg.getBBox();
            _bbox.svg = null;
            _bbox.width = Math.abs(lmitem.bounds.x1 - lmitem.bounds.x2);
            _bbox.height = Math.abs(lmitem.bounds.y1 - lmitem.bounds.y2);
            _bbox.area = _bbox.width * _bbox.height;
            _bbox.detail = lmitem.bounds;
            _bbox.color = (lmitem.fill !== undefined ? lmitem.stroke : lmitem.fill);
            _bbox.origin_box = { x: xbound, y: ybound, width: lmitem.mark.group.width, height: lmitem.mark.group.height };
            _bbox.absBox = {
              x1: xbound + lmitem.x - _bbox.width / 2,
              x2: xbound + lmitem.x + _bbox.width / 2,
              y1: ybound + lmitem.y - _bbox.height / 2,
              y2: ybound + lmitem.y + _bbox.height / 2
            };
            _bbox.absBox.xc = (_bbox.absBox.x1 + _bbox.absBox.x2) / 2;
            _bbox.absBox.yc = (_bbox.absBox.y1 + _bbox.absBox.y2) / 2;
            _bbox.individual = true;
            _bbox.markType = lmitem.ariaRoleDescription;
            _bbox.markShape = (_bbox.marktype === "square" ? "rect" : "circle");

          }
          // else if (["area"].includes(lmitem.mark.marktype)) {
          //   _bbox.width = lmitem.mark.group.width / layer_lm_items.length;
          //   _bbox.height = lmitem.height;
          //   _bbox.area = _bbox.width * _bbox.height;
          //   _bbox.detail = lmitem.bounds;
          //   _bbox.color = lmitem.fill;
          //   _bbox.origin_box = { x: xbound, y: ybound, width: lmitem.mark.group.width, height: lmitem.mark.group.height };
          //   _bbox.absBox = {
          //     x1: xbound + Math.max(0, lmitem.x - (_bbox.width) / 2),
          //     x2: xbound + Math.min(lmitem.mark.group.width, lmitem.x + (_bbox.width) / 2),
          //     y1: ybound + lmitem.y,
          //     y2: ybound + lmitem.y2
          //   };
          //   if (_bbox.absBox.x1 == 0) _bbox.absBox.xc = _bbox.absBox.x1;
          //   else if (_bbox.absBox.x2 == lmitem.mark.group.width) _bbox.absBox.xc = _bbox.absBox.x2;
          //   else _bbox.absBox.xc = (_bbox.absBox.x1 + _bbox.absBox.x2) / 2;
          //   _bbox.absBox.yc = (_bbox.absBox.y1 + _bbox.absBox.y2) / 2
          //   _bbox.individual = false;
          //   _bbox.markType = lmitem.mark.marktype;
          //   _bbox.markShape = "area";
          //   _bbox.orient = lmitem.orient;
          // } 
          else if (["line", "area"].includes(lmitem.mark.marktype)) {
            _bbox.detail = lmitem.bounds;
            _bbox.color = lmitem.stroke;
            _bbox.thickness = lmitem.strokeWidth;
            _bbox.origin_box = { x: xbound, y: ybound, width: lmitem.mark.group.width, height: lmitem.mark.group.height };
            //use items 
            if (lmitem.mark.line_points === undefined) {
              let line_count = 0;
              lmitem.mark.line_points = lmitem.mark.items.map(function (e) {
                if (e.hasOwnProperty('_svg')) line_count += 1;
                let lpx = [e.x - (lmitem.strokeWidth || 1) / 2, e.x + (lmitem.strokeWidth || 1) / 2];
                let lpy = [e.y - (lmitem.strokeWidth || 1) / 2, e.y + (lmitem.strokeWidth || 1) / 2];
                return {
                  x: lpx,
                  y: lpy,
                  description: e.description,
                  line_id: line_count
                };
              });
            }
            // line reconstruction
            let line_seg = [];
            let dimy = [], dimx = [];
            for (const li in lmitem.mark.line_points) {
              let line_point = lmitem.mark.line_points[li];
              if (line_point.description === lmitem.description) {
                // half point!
                let lin = parseInt(li);
                let pli = lmitem.mark.line_points[lin];
                if (lin > 0) {
                  let pli0 = lmitem.mark.line_points[lin - 1];
                  if (pli0.line_id === pli.line_id) {
                    let pli05 = {
                      x: [(pli0.x[0] + pli.x[0]) / 2, (pli0.x[1] + pli.x[1]) / 2],
                      y: [(pli0.y[0] + pli.y[0]) / 2, (pli0.y[1] + pli.y[1]) / 2]
                    }
                    line_seg.push(pli05);
                    dimx.push(pli05.x[0]);
                    dimx.push(pli05.x[1]);
                    dimy.push(pli05.y[0]);
                    dimy.push(pli05.y[1]);
                  }
                }
                line_seg.push(pli);
                dimx.push(pli.x[0]);
                dimx.push(pli.x[1]);
                dimy.push(pli.y[0]);
                dimy.push(pli.y[1]);
                if (lin < lmitem.mark.line_points.length - 1) {
                  let pli0 = lmitem.mark.line_points[lin + 1];
                  if (pli0.line_id === pli.line_id) {
                    let pli05 = {
                      x: [(pli0.x[0] + pli.x[0]) / 2, (pli0.x[1] + pli.x[1]) / 2],
                      y: [(pli0.y[0] + pli.y[0]) / 2, (pli0.y[1] + pli.y[1]) / 2]
                    }
                    line_seg.push(pli05);
                    dimx.push(pli05.x[0]);
                    dimx.push(pli05.x[1]);
                    dimy.push(pli05.y[0]);
                    dimy.push(pli05.y[1]);
                  }
                };
              }
            }
            _bbox.line_segment = line_seg;

            _bbox.width = Math.max(...dimx) - Math.min(...dimx);
            _bbox.height = Math.max(...dimy) - Math.min(...dimy);
            _bbox.area = _bbox.width * _bbox.height;
            _bbox.absBox = {
              x1: xbound + lmitem.x - _bbox.width / 2,
              x2: xbound + lmitem.x + _bbox.width / 2,
              y1: ybound + lmitem.y - _bbox.height / 2,
              y2: ybound + lmitem.y + _bbox.height / 2
            };
            if (_bbox.absBox.x1 == 0) _bbox.absBox.xc = _bbox.absBox.x1;
            else if (_bbox.absBox.x2 == lmitem.mark.group.width) _bbox.absBox.xc = _bbox.absBox.x2;
            else _bbox.absBox.xc = (_bbox.absBox.x1 + _bbox.absBox.x2) / 2;
            _bbox.absBox.yc = (_bbox.absBox.y1 + _bbox.absBox.y2) / 2;
            _bbox.individual = false;
            _bbox.markType = lmitem.mark.marktype;
            _bbox.markShape = "line";
            _bbox.direction = getLineDirection(m["x"]["datatype_class"], m["y"]["datatype_class"]);
          } else if (["rule"].includes(lmitem.mark.marktype)) {
            _bbox.svg = null;
            _bbox.width = lmitem.width;
            _bbox.height = lmitem.height;
            _bbox.area = _bbox.width * _bbox.height;
            _bbox.detail = lmitem.bounds;
            _bbox.color = lmitem.stroke;
            _bbox.thickness = lmitem.strokeWidth;
            _bbox.origin_box = { x: xbound, y: ybound, width: lmitem.mark.group.width, height: lmitem.mark.group.height };
            _bbox.absBox = {
              x1: xbound + lmitem.x,
              x2: xbound + lmitem.x2,
              y1: ybound + lmitem.y - _bbox.height / 2,
              y2: ybound + lmitem.y + _bbox.height / 2
            };
            _bbox.absBox.xc = (_bbox.absBox.x1 + _bbox.absBox.x2) / 2;
            _bbox.absBox.yc = (_bbox.absBox.y1 + _bbox.absBox.y2) / 2;
            _bbox.individual = true;
            _bbox.markType = lmitem.mark.marktype;
            _bbox.markShape = "rect";
          } else if (["text"].includes(lmitem.mark.marktype)) {
            _bbox.svg = null;
            _bbox.width = lmitem.width;
            _bbox.height = lmitem.height;
            _bbox.area = _bbox.width * _bbox.height;
            _bbox.detail = lmitem.bounds;
            _bbox.color = lmitem.fill;
            _bbox.origin_box = { x: xbound, y: ybound, width: lmitem.mark.group.width, height: lmitem.mark.group.height };
            _bbox.absBox = {
              y1: ybound + lmitem.y - _bbox.height / 2,
              y2: ybound + lmitem.y + _bbox.height / 2
            };
            if (lmitem.align === "left") {
              _bbox.absBox.x1 = xbound + lmitem.x;
              _bbox.absBox.x2 = xbound + lmitem.x + _bbox.width;
            } else if (lmitem.align === "right") {
              _bbox.absBox.x1 = xbound + lmitem.x - _bbox.width;
              _bbox.absBox.x2 = xbound + lmitem.x;
            } else {
              _bbox.absBox.x1 = xbound + lmitem.x - _bbox.width / 2;
              _bbox.absBox.x2 = xbound + lmitem.x + _bbox.width / 2;
            }
            _bbox.absBox.xc = (_bbox.absBox.x1 + _bbox.absBox.x2) / 2;
            _bbox.absBox.yc = (_bbox.absBox.y1 + _bbox.absBox.y2) / 2;
            _bbox.individual = true;
            _bbox.markType = lmitem.mark.marktype;
            _bbox.markShape = "rect";
          }
          _bbox.vegaid = lmitem[Object.getOwnPropertySymbols(lmitem)[0]];
          _bbox.opacity = (lmitem.opacity ? lmitem.opacity : 1);
          _bbox.shape = (lmitem.shape ? lmitem.shape : undefined);
          if (lmitem.mark.marktype === "text") {
            _bbox.shape = lmitem.text;
          }
          if (_bbox.color !== undefined && _bbox.color !== null && !util.isAtomic(_bbox.color) && _bbox.color.hasOwnProperty("gradient")) {
            //gradient
            let grident_elems = _bbox.color.stops.map(function (e) { return color.decodeRgb(e.color); })
            _bbox.color = util.matrxiAvgByRow(grident_elems);
          }
          if (_bbox.color === "transparent") _bbox.color = undefined;
          let _role = (lmitem.description?.split(";")?.length === 1 && _bbox.markType === "text" ? "label" : "mark");
          mark_items.push({
            "e": m,
            "d": _d,
            "s": (lmitem.subgroup ? i.toString() + "_" + lmitem.subgroup : ""),
            "b": _bbox,
            "parent": parent,
            "r": _role
          }); //save temporarily
        }
        // x, x2, y, y2 recalculation
        let mark_items_t = util.transposeObject(mark_items.map(function (x) { return x.e }));
        for (let [key, value] of Object.entries(mark_items_t)) {
          mark_items_t[key] = value.map(function (e) { return e.value });
        }
        let except_invariant = ['color', 'shape', 'text', 'size', 'opacity', 'detail'];
        let invariants = Object.keys(mark_items_t).map(function (k) {
          if (mark_items_t[k].length == 1) return undefined;
          else if (util.isArrayInvariant(mark_items_t[k]) && !except_invariant.includes(util.vgEncConversion[k])) return k;
          else if (util.isArrayInvariant(mark_items_t[k]) && util.vgEncConversion[k] == "x" && Object.keys(util.vgEncConversion[k]).includes("x2")) return undefined;
          else if (util.isArrayInvariant(mark_items_t[k]) && util.vgEncConversion[k] == "y" && Object.keys(util.vgEncConversion[k]).includes("y2")) return undefined;
          else return undefined
        }).filter(function (e) {
          return e !== undefined
        });
        let invariants_xy2 = Object.keys(mark_items_t).map(function (k) {
          if (util.isArrayInvariant(mark_items_t[k])) return k;
          else return undefined;
        }).filter(function (e) {
          return e !== undefined
        });
        let skip_invariants = [];
        // xy plane revision, remove undefined
        for (let vf of mark_items) {
          // x & x2 ==> lx
          vf.c = {}
          for (let chn in vf.e) {
            if (!invariants_xy2.includes(chn)) {
              vf.c[chn] = {
                field: vf.e[chn].field,
                value: vf.e[chn].value,
                datatype: vf.e[chn].datatype,
                datatype_class: vf.e[chn].datatype_class
              }
            }
          }
          if (vf.e.x && vf.e.x2 && !invariants_xy2.includes("x2") && !invariants_xy2.includes("x")) {
            let xplt1 = (vf.e.x.field ? vf.e.x.field.split("_") : []), xplt2 = (vf.e.x2.field ? vf.e.x2.field.split("_") : []);
            if (xplt1.length > 1 && xplt2.length > 1) {
              let rfld1 = xplt1.slice(0, xplt1.length - 1).join("_"), lmrk1 = xplt1[xplt1.length - 1];
              let rfld2 = xplt2.slice(0, xplt2.length - 1).join("_"), lmrk2 = xplt2[xplt2.length - 1];
              if (((lmrk1 === "start" && lmrk2 === "end") || (lmrk1 === "end" && lmrk2 === "start")) && rfld1 === rfld2) {
                vf.e.lx = {
                  field: rfld1,
                  value: Math.abs(vf.e.x.value - vf.e.x2.value),
                  datatype: vf.e.x.datatype,
                  datatype_class: vf.e.x.datatype_class
                }
                delete vf.e.x;
                delete vf.e.x2;
                if (vf.c.x) vf.c.x.field = rfld1;
                if (vf.c.x2) vf.c.x2.field = rfld1;
              }
            }
          } else if (vf.e.x && vf.e.x2 && invariants_xy2.includes("x2") && !invariants_xy2.includes("x")) {
            let isFSE = (vf.e.x.field.endsWith("_end") && vf.e.x2.field.endsWith("_start")) || (vf.e.x.field.endsWith("_start") && vf.e.x2.field.endsWith("_end"));
            if (isFSE) vf.e.x.field = vf.e.x.field.replace(/\_(start|end)$/, "")
            delete vf.e.x2;
          } else if (vf.e.x && vf.e.x2 && !invariants_xy2.includes("x2") && invariants_xy2.includes("x")) {
            let isFSE = (vf.e.x.field.endsWith("_end") && vf.e.x2.field.endsWith("_start")) || (vf.e.x.field.endsWith("_start") && vf.e.x2.field.endsWith("_end"));
            let nf = vf.e.x2.field.replace(/\_(start|end)$/, "");
            vf.e.x = {
              field: isFSE ? nf : vf.e.x2,
              value: vf.e.x2.value,
              datatype: vf.e.x2.datatype,
              datatype_class: vf.e.x2.datatype_class,
            }
            skip_invariants.push("x");
            delete vf.e.x2;
          }

          // y & y2 ==> ly
          if (vf.e.y && vf.e.y2 && !invariants_xy2.includes("y2") && !invariants_xy2.includes("y")) {
            let yplt1 = (vf.e.y.field ? vf.e.y.field.split("_") : []), yplt2 = (vf.e.y2.field ? vf.e.y2.field.split("_") : []);
            if (yplt1.length > 1 && yplt2.length > 1) {
              let rfld1 = yplt1.slice(0, yplt1.length - 1).join("_"), lmrk1 = yplt1[yplt1.length - 1];
              let rfld2 = yplt2.slice(0, yplt2.length - 1).join("_"), lmrk2 = yplt2[yplt2.length - 1];
              if (((lmrk1 === "start" && lmrk2 === "end") || (lmrk1 === "end" && lmrk2 === "start")) && rfld1 === rfld2) {
                vf.e.ly = {
                  field: rfld1,
                  value: Math.abs(vf.e.y.value - vf.e.y2.value),
                  datatype: vf.e.y.datatype,
                  datatype_class: vf.e.y.datatype_class
                }
                delete vf.e.y;
                delete vf.e.y2;
                if (vf.c.y) vf.c.y.field = rfld1;
                if (vf.c.y2) vf.c.y2.field = rfld1;
              }
            }
          } else if (vf.e.y && vf.e.y2 && invariants_xy2.includes("y2") && !invariants_xy2.includes("y")) {
            let isFSE = (vf.e.y.field.endsWith("_end") && vf.e.y2.field.endsWith("_start")) || (vf.e.y.field.endsWith("_start") && vf.e.y2.field.endsWith("_end"));
            if (isFSE) vf.e.y.field = vf.e.y.field.replace(/\_(start|end)$/, "")
            delete vf.e.y2;
          } else if (vf.e.y && vf.e.y2 && !invariants_xy2.includes("y2") && invariants_xy2.includes("y")) {
            let isFSE = (vf.e.y.field.endsWith("_end") && vf.e.y2.field.endsWith("_start")) || (vf.e.y.field.endsWith("_start") && vf.e.y2.field.endsWith("_end"));
            let nf = vf.e.y2.field.replace(/\_(start|end)$/, "");
            vf.e.y = {
              field: isFSE ? nf : vf.e.y2.field,
              value: vf.e.y2.value,
              datatype: vf.e.y2.datatype,
              datatype_class: vf.e.y2.datatype_class,
            }

            skip_invariants.push("y");
            delete vf.e.y2;
          }

          if (vf.e.lx && vf.e.x2 && vf.e.lx.field === vf.e.x2.field) {
            delete vf.e.x2;
          }
          if (vf.e.lx && vf.e.x && vf.e.lx.field === vf.e.x.field) {
            delete vf.e.lx;
          }

          if (vf.e.ly && vf.e.y2 && vf.e.ly.field === vf.e.y2.field) {
            delete vf.e.y2;
          }
          if (vf.e.ly && vf.e.y && vf.e.ly.field === vf.e.y.field) {
            delete vf.e.ly;
          }

          let vfs = Object.keys(vf.e);
          vfs.forEach(function (vfel) {
            if (vf.e[vfel].field === undefined) delete vf.e[vfel];
            if (invariants.includes(vfel) && !skip_invariants.includes(vfel)) delete vf.e[vfel];
          });
          if (vf.e.y2 && vf.e.y && vf.e.y.field === vf.e.y2.field) {
            delete vf.e.y2;
          }
          if (vf.e.x2 && vf.e.x && vf.e.x.field === vf.e.x2.field) {
            delete vf.e.x2;
          }
        }

        let used_encodings = new Set();

        for (let vf of mark_items) {
          vf.b.xy = {};
          for (let [key, value] of Object.entries(vf.e)) {
            if (key === "x" || key === "xc") vf.b.xy["x"] = value;
            else if (key === "x2") vf.b.xy["x2"] = value;
            else if (key === "y" || key === "yc") vf.b.xy["y"] = value;
            else if (key === "y2") vf.b.xy["y2"] = value;
            else vf.b.xy[key] = value;
            used_encodings.add(key);
          }
        }

        encoding_set[i.toString() + "_" + lm.name] = { // encoding set
          "mark": lm.type,
          "items": mark_items,
          "encodings": Array.from(used_encodings)
        }; // for each layer, saves the mark type (mark) and mark items (items).
      }
    }
  }

  // get root information
  let root;
  if (context === "facets") {
    root = $org_data.root.values.value[0].bounds;
    await processRawFacets();
  } else if (context === "layers") {
    root = $state.root.values.value[0].bounds;
    await processRawLayers();
  }

  await processScale();

  await processEncoding();


  let annotation_set = [];
  // $compiledFronto.annotation?.data?.items?.forEach((anno) => {
  //   if (anno.text?.value) {
  //     let [width, height, x, y] = get_annotation_size(anno);
  //     annotation_set.push({
  //       x, y,
  //       width, height
  //     })
  //   }
  // });
  // $compiledFronto.annotation?.nondata?.items?.forEach((anno) => {
  //   if (anno?.anchor) annotation_set.push(anno.anchor.dataBBox);
  // });

  Object.keys(internal_texts).forEach((t) => {
    annotation_set.push(...internal_texts[t]);
  })

  return {
    n_layers,
    field_set,
    encoding_set,
    scales_set,
    vega_spec: original_spec,
    vl_spec,
    context,
    input_data: original_dataset,
    size: $size,
    root,
    annotation_set,
    fronto_spec,
    chart_size,
  }
}

function remove_bin_aux(bin_str) {
  return bin_str.replace(/(bin_maxbins_[0-9]+_)/i, "")
}

// function get_annotation_size(anno) {
//   let a = document.createElement("DIV");
//   a.innerHTML = anno.text.value;
//   let text = Array.from(a.children).map(d => [d.textContent, d.style.fontSize]);
//   let width = Math.max(...text.map(d => getDefaultBoxWidth(d[0], d[1] || 14)));
//   let height = text.reduce((acc, d) => acc + (d[1] || 14), 0);
//   let x = anno.x || 0;
//   let y = anno.y || 0;

//   if (anno.cssTransform) {
//     let transform_parsed = parseCSSTransform(anno.cssTransform);
//     transform_parsed?.forEach((t) => {
//       if (t[0] === "x") {
//         if (t[2] === "px") {
//           x += t[1];
//         } else if (t[2] === "%") {
//           x += (width * (t[1] / 100));
//         } else if (t[2] === "rem" || t[2] === "em") {
//           x += (t[1] * 16);
//         }
//       } else if (t[0] === "y") {
//         if (t[2] === "px") {
//           y += t[1];
//         } else if (t[2] === "%") {
//           y += (height * (t[1] / 100));
//         } else if (t[2] === "rem" || t[2] === "em") {
//           y += (t[1] * 16);
//         }
//       }
//     });
//   }
//   return [width, height, x, y];
// }

function parseCSSTransform(cssTransform) {
  return cssTransform.split(" ").map((t) => {
    let s = t.match(/^([a-zA-Z]+)\((\-?[0-9]+[\.]?[0-9]*)(px|\%|em|rem|in|cm)\)$/);
    if (s) {
      if (s[1] === "translateX") {
        return ["x", parseFloat(s[2]), s[3]]
      } else if (s[1] === "translateY") {
        return ["y", parseFloat(s[2]), s[3]]
      }
    }
    return []
  })
}

// letter width setup
const letterWidth = {
  // scaled at font height 12px
  A: 7,
  a: 7,
  B: 8,
  b: 7,
  C: 8,
  c: 6,
  D: 9,
  d: 7,
  E: 7,
  e: 7,
  F: 7,
  f: 4,
  G: 9,
  g: 7,
  H: 9,
  h: 7,
  I: 3,
  i: 3,
  J: 5,
  j: 3,
  K: 8,
  k: 6,
  L: 7,
  l: 3,
  M: 11,
  m: 11,
  N: 9,
  n: 7,
  O: 9,
  o: 7,
  P: 8,
  p: 7,
  Q: 9,
  q: 7,
  R: 8,
  r: 4,
  S: 8,
  s: 6,
  T: 7,
  t: 4,
  U: 9,
  u: 7,
  V: 7,
  v: 6,
  W: 11,
  w: 9,
  X: 7,
  x: 6,
  Y: 7,
  y: 6,
  Z: 7,
  z: 5,
  ".": 2,
  ",": 2,
  ":": 2,
  ";": 2,
  others: 9,
  number: 5,
};
function getDefaultBoxWidth(text, height) {
  if (text !== undefined) {
    let textRows = text.split(/\<br\/+\>/g);
    textRows = textRows.map(row => { return row.replace(/\<\/?[^\>]+\>/g, "") });
    let rowWidths = textRows.map((row) => {
      let textSplit = row.replace(/(\<.+\"\>)/g, "").split("");
      return (textSplit.map((d) => (letterWidth[d] ? letterWidth[d] : parseInt(d) || d === "0" ? letterWidth.number : letterWidth.others)).reduce((a, d) => a + d, 0) * height) / 11;
    });
    return Math.max(...rowWidths);
  } else {
    return 0;
  }
}

function getLineDirection(dtypeX, dtypeY) {
  // rule-based
  if (dtypeX === "nominal") {
    return "horizontal";
  } else if (dtypeY === "nominal") {
    return "vertical";
  } else if (dtypeX === "ordinal") {
    return "horizontal";
  } else if (dtypeY === "ordinal") {
    return "vertical";
  } else if (dtypeX === "temporal") {
    return "horizontal";
  } else if (dtypeY === "temporal") {
    return "vertical";
  }
  // just in case;
  return "vertical";
}